import gql from "graphql-tag";

export const contact = gql`
  mutation Contact($contactRequest: ContactRequest!) {
    contact(contactRequest: $contactRequest)
  }
`;
